import { onlyForBetaUsers } from 'common/conditionalHOC';
import React from 'react';

const IoBtns = () => {
  return (
   <></>
  );
};

IoBtns.propTypes = {};

export default onlyForBetaUsers(IoBtns);
